import clsx from 'clsx';
import * as R from 'ramda';

import { schema } from './collinsMpcConstants';
import { getAttributeDataRows } from './collinsMpcUtilities';

import classes from './collinsMpcPdfReport.module.css';

interface Props {
  workOrderAsset: any;
}

const GeneralNotes = ({ workOrderAsset }: Props) => {
  const generalNotes = getAttributeDataRows(workOrderAsset?.attributes, [
    schema.inspectionData.generalNotes,
  ]);

  const value = R.pathOr('', [0, 'value'], generalNotes);

  return (
    <div className={clsx(classes.sectionBox, classes.noMargin)}>
      <div className={classes.sectionTitle}>General Notes</div>
      <div className={classes.noteContent}>{value}</div>
    </div>
  );
};

export default GeneralNotes;
